// import ProductFilter from '../ProductFilter/ProductFilter.vue';
// import TopBar from '../TopBar/TopBar.vue';
import Pagination from 'presentation/components/Pagination/Pagination.vue';
import Spinner from 'presentation/components/Spinner/Spinner.vue';
import ProductThumbnail from './ProductThumbnail/ProductThumbnail.vue';
import { useI18n } from 'vue-i18n';
import useProductTools from 'hooks/useProductTools';
import useCartTools from 'hooks/useCartTools';
import algoliasearch from "algoliasearch/lite";
import useSearch from 'hooks/useSearch';
import { shallowRef } from 'vue';
import Toast from 'presentation/components/Toast/Toast.vue';

export default {
  name: 'ProductList',
  components: {
    Spinner,
    ProductThumbnail,
    Pagination,
    Toast
    // ProductFilter,
    // TopBar,
  },
  setup() {
    const { t } = useI18n();
    const { addLine } = useCartTools();
    const {
      formatProduct,
      total,
      loading,
      page,
      error,
      setPage,
      products
    } = useProductTools();
    const toastMessage = shallowRef(null);
    const toastType = shallowRef(null);
    const setToast = (message, type) => {
      if(message){
        toastMessage.value = message;
        toastType.value = type;

        setTimeout(()=>{
          toastMessage.value = null;
          toastType.value = null;
        }, 3000);
      }
    }
    const addToCart = (sku, quantity = 1) =>
      addLine(sku, quantity)
      .then(()=>setToast("Item Added To cart", 'success'))
      .catch((err)=>{
        console.error(err);
        setToast("Something went wrong", 'error')
      })
    return {
      t,
      formatProduct,
      total,
      loading,
      page,
      setPage,
      products,
      error,
      addToCart,
      searchClient: algoliasearch(
        "JJEZV8DVX2",
        "b8f13d2302cc9d4b116f6ff6cab0ce6c"
      ),
      storeId: localStorage.getItem("storeRef") ? localStorage.getItem("storeRef") : 'shoes-store',
      toastMessage,
      toastType
    };
  },
  computed: {
    haveRouteParam() {
      if (this.$route.params.categorySlug) {
        return true;
      }
      return false;
    },
    searchQuery() {
      const { search: s } = useSearch();
      const search = shallowRef(s.value);
      if(search.value) {
        return search.value;
      } else {
        if (this.$route.params.categorySlug) {
          return this.$route.params.categorySlug;
        } else {
          return '';
        }
      }
    }
  }
};
